import {
  GET_VENDOR_PRICING_SUCCESS,
  GET_VENDOR_PRICING_FAIL,
  GET_VENDOR_PRICING_PROFILE_SUCCESS,
  GET_VENDOR_PRICING_PROFILE_FAIL,
  ADD_VENDOR_PRICING_SUCCESS,
  ADD_VENDOR_PRICING_FAIL,
  UPDATE_VENDOR_PRICING_SUCCESS,
  UPDATE_VENDOR_PRICING_FAIL,
  DELETE_VENDOR_PRICING_SUCCESS,
  DELETE_VENDOR_PRICING_FAIL,
  DELETE_VENDOR_PRICING,
  ADD_NEW_VENDOR_PRICING,
  UPDATE_VENDOR_PRICING
  
} from "./actionTypes";

const INIT_STATE = {
  data: [],
  vendor_pricingProfile: {},
  error: {},
  loading:false
};

const vendor_pricing = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_VENDOR_PRICING_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        total_page:action.payload.total_page
      }

    case GET_VENDOR_PRICING_FAIL:
      return {
        ...state,
        error: action.payload,
      }
      case ADD_NEW_VENDOR_PRICING:
        return {
          ...state,
          loading:true
        }
    case ADD_VENDOR_PRICING_SUCCESS:
      return {
        ...state,
        data: [...state.data, action.payload],
        loading:false
      }

    case ADD_VENDOR_PRICING_FAIL:
      return {
        ...state,
        error: action.payload,
        loading:false
      }
      case UPDATE_VENDOR_PRICING:
        return {
          ...state,
          loading:true
        }
    case UPDATE_VENDOR_PRICING_SUCCESS:
      return {
        ...state,
        data: state.data.map(d =>
          d.id.toString() === action.payload.id.toString()
            ? { ...d, ...action.payload }
            : d
        ),
        loading:false
      }

    case UPDATE_VENDOR_PRICING_FAIL:
      return {
        ...state,
        error: action.payload,
        loading:false
      }
    case DELETE_VENDOR_PRICING:
      return {
        ...state,
        loading:true
      }
    case DELETE_VENDOR_PRICING_SUCCESS:
      return {
        ...state,
        data: state.data.filter(
          d => d.id.toString() !== action.payload.id.toString()
        ),
        loading:false
      }

    case DELETE_VENDOR_PRICING_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_VENDOR_PRICING_PROFILE_SUCCESS:
      return {
        ...state,
        vendor_catProfile: action.payload,
      }

    case GET_VENDOR_PRICING_PROFILE_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    default:
      return state
  }
};

export default vendor_pricing;
